import React from "react";
import ReactDOM from "react-dom";
import styles from "./style.module.scss";
import { useTranslation } from "react-i18next";
import { StealthModelAnimation } from "./components/StealthModelAnimation";

interface StealthModelPopupProps {
    isOpen: boolean;
    onClose: () => void;
    onUpgrade: () => void;
}

export const StealthModelPopup: React.FC<StealthModelPopupProps> = ({ 
    isOpen, 
    onClose,
    onUpgrade
}) => {
    const { t } = useTranslation();

    const handleBackdropClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <div className={styles.StealthModelPopup} onClick={handleBackdropClick}>
            <div className={styles.StealthModelPopup__modal}>
                <button 
                    className={styles.StealthModelPopup__closeButton} 
                    onClick={(e) => {
                        e.stopPropagation();
                        onClose();
                    }}
                >
                    ×
                </button>
                
                <div className={styles.StealthModelPopup__header}>
                    <h2 className={styles.StealthModelPopup__title}>
                       <span className={styles.StealthModelPopup__highlight}>
                           {t('enhancedModelToast.title', "Unlock Your Unfair Advantage")}
                       </span>
                    </h2>
                </div>

                <div className={styles.StealthModelPopup__mainContent}>
                    <div className={styles.StealthModelPopup__leftColumn}>
                        <p className={`${styles.StealthModelPopup__description} ${styles.hideOnMobile}`}>
                            {t('enhancedModelToast.desc1', "The Stealth Model is truly game-changing")}
                        </p>
                        <p className={styles.StealthModelPopup__description}>
                            {t('enhancedModelToast.desc2', "Our Best Private AI Model")}
                        </p>
                        <div className={styles.StealthModelPopup__features}>
                            <div className={styles.StealthModelPopup__feature}>
                                <span className={styles.StealthModelPopup__checkmark}>✓</span>
                                <span>{t("upsell.feature1") || "Helps with recent GPTZero & Turnitin updates"}</span>
                            </div>
                            <div className={styles.StealthModelPopup__feature}>
                                <span className={styles.StealthModelPopup__checkmark}>✓</span>
                                <span>{t("upsell.feature2") || "Advanced text processing algorithms"}</span>
                            </div>
                            <div className={styles.StealthModelPopup__feature}>
                                <span className={styles.StealthModelPopup__checkmark}>✓</span>
                                <span>{t("upsell.feature3") || "Lifetime access - pay once, use forever"}</span>
                            </div>
                        </div>
                    </div>
                    <div className={styles.StealthModelPopup__rightColumn}>
                        <StealthModelAnimation />
                    </div>
                </div>

                <div className={styles.StealthModelPopup__footer}>
                    <div className={styles.StealthModelPopup__buttonSection}>
                        <button
                            onClick={onUpgrade}
                            className={styles.StealthModelPopup__payButton}
                        >
                            Try Now
                        </button>
                    </div>
                </div>
            </div>
        </div>,
        document.body
    );
};